export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: '泡在我家的辣妹漫画讲了什么？',
    a: '故事以"辣妹少女寄居在普通男高中生家里"为切入点，讲述两个性格迥异的高中生在同一屋檐下的吵闹日常与逐渐升温的感情。它是一篇轻松的青春恋爱喜剧，主线围绕"寄居"的缘起、日常的磨合与心意的坦白层层展开。',
  },
  {
    q: '作品的核心设定是什么？',
    a: '核心设定是"反差"与"同处一室的日常"。女主角是外表张扬的辣妹，却藏着漫画迷的柔软一面；男主角是安静内向的漫画收藏家。两人因为一次寄居而被迫共享生活空间，在笑料与心动中建立羁绊。',
  },
  {
    q: '主要角色有哪些？',
    a: '主要角色包括：女主角、爱看漫画的辣妹黑田美咲，男主角、漫画收藏家佐藤悠斗，美咲的闺蜜藤井千夏，悠斗的妹妹佐藤美琴，以及悠斗的死党高桥和真。',
  },
  {
    q: '剧情的主线走向是怎样的？',
    a: '主线大体分为三阶段：第一阶段是"寄居开始"，交代两人被迫同住的缘起；第二阶段是"日常磨合"，在生活与校园的日常里逐渐拉近距离；第三阶段是"心意坦白"，在暑假与集体活动中感情升温，最终走向彼此。',
  },
  {
    q: '分集剧情在哪里可以查看？',
    a: '本站在"分集剧情"栏目整理了各话的剧情梗概与看点，按顺序逐集更新，方便你在看漫画前快速补课，也能帮你回顾错过的关键情节。',
  },
  {
    q: '适合什么样的读者阅读？',
    a: '适合喜欢轻松校园恋爱喜剧、偏爱"反差萌"与温馨日常设定的读者。如果你对内向男主与外向辣妹的化学反应感兴趣，这部作品会非常对味。',
  },
  {
    q: '作品会一直更新吗？剧情是否已完结？',
    a: '目前故事仍在连载中，剧情尚未完结。本站在各话更新后会在"分集剧情"栏目同步整理新的剧情梗概，建议收藏本页持续关注。',
  },
  {
    q: '看漫画之前需要了解哪些背景知识？',
    a: '基本无需额外背景知识即可直接阅读。若想更快进入状态，可以先浏览本页"漫画介绍与设定"，快速了解人物关系和主线脉络，再进入分集剧情会更顺畅。',
  },
];